import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../../api/api';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../../state/hooks';
import { loginSuccess } from '../../state/auth';

const Verify2faPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { email, name, otpauthUrl } = location.state || {};
  const [twoFactorAuthCode, setTwoFactorAuthCode] = useState('');

  const handleVerify2fa = async () => {
    try {
      const response = await api.post('/api/auth/verify-2fa', {
        email,
        code: twoFactorAuthCode,
      });

      if (response.data.success) {
        localStorage.setItem('token', response.data.accessToken);
        sessionStorage.setItem('email', email);
        dispatch(loginSuccess(response.data.name));
        navigate('/');
        toast.success('2FA verified successfully!');
      } else {
        toast.error(response.data.error || '2FA verification failed.');
      }
    } catch (error) {
      console.error('2FA verification error:', error);
      toast.error('An error occurred during 2FA verification.');
    }
  };

  if (!email || !otpauthUrl) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white">
        <p>Error: Missing 2FA information. Please try logging in again.</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg text-center">
        <h2 className="text-2xl font-bold mb-4">Verify Two-Factor Authentication</h2>
        <p className="mb-4">Scan the QR code with your authenticator app or enter the code manually:</p>
        {otpauthUrl && (
          <img
            src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(otpauthUrl)}`}
            alt="QR Code"
            className="my-4 mx-auto"
          />
        )}
        <input
          type="text"
          className="w-full p-2 mb-4 rounded bg-gray-700 text-white border border-gray-600 focus:outline-none focus:border-blue-500"
          placeholder="Enter 2FA Code"
          value={twoFactorAuthCode}
          onChange={(e) => setTwoFactorAuthCode(e.target.value)}
        />
        <button
          onClick={handleVerify2fa}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Verify Code
        </button>
      </div>
    </div>
  );
};

export default Verify2faPage;
